"use client";

import React from "react";

export type DaysCellState =
  | "Default"
  | "Today"
  | "Focus"
  | "Hover"
  | "Interval"
  | "Next Month"
  | "Disabled";

/** The seven day-cell variants from the Animalia component library. */
const DaysCells = ({
  label,
  state = "Default",
  selected = false,
  disabled = false,
  onClick,
  ariaLabel,
}: {
  label: string;
  state?: DaysCellState;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  ariaLabel?: string;
}) => {
  const active = selected;
  const className = [
    "ani-day",
    `ani-day--${state.toLowerCase().replace(" ", "-")}`,
    active ? "ani-day--selected" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={className}
      disabled={disabled || state === "Disabled"}
      aria-label={ariaLabel ?? label}
      aria-pressed={active}
      aria-current={state === "Today" ? "date" : undefined}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default DaysCells;
